import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@app/core/services/base-http.service';
import { CacheService } from './cache.service';
import { CurrencyListItem } from '../models/common.model';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService extends BaseHttpService {
  private _cacheService = inject(CacheService);

  getAllCurrencies(): Observable<CurrencyListItem[]> {
    return this._cacheService.cacheObservable(
      '/api/currency',
      this.httpClient.get<CurrencyListItem[]>(`${this.baseApiUrl}/api/currency`)
    );
  }
}
